import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiClock, FiSend, FiMessageSquare } = FiIcons;

const ContactPage = () => {
  const contactInfo = [
    { icon: FiMail, title: "Email", detail: "halo@akademikasupport.id", subDetail: "Respon dalam 24 jam" },
    { icon: FiPhone, title: "WhatsApp", detail: "+62 812-3456-7890", subDetail: "Senin - Jumat, 09.00 - 17.00" },
    { icon: FiMapPin, title: "Lokasi", detail: "Jakarta, Indonesia", subDetail: "Layanan Seluruh Indonesia" }
  ];

  return (
    <div className="bg-white font-inter">
      {/* Header Section - Updated to a slightly deeper, elegant slate gradient for better definition */}
      <section className="bg-gradient-to-b from-slate-200/50 via-slate-100/20 to-white py-24 border-b border-divider relative overflow-hidden">
        {/* Subtle background decorative element */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-extrabold text-primary mb-6 tracking-tight"
          >
            Hubungi Kami
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-lg md:text-xl text-secondary font-medium"
          >
            Kami siap mendengarkan kebutuhan akademik Bapak/Ibu. Silakan hubungi kami melalui formulir di bawah ini atau kanal komunikasi lainnya.
          </motion.p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
            
            {/* Contact Info Cards */}
            <div className="space-y-8">
              {contactInfo.map((info, idx) => (
                <motion.div 
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  viewport={{ once: true }}
                  className="p-8 border border-divider rounded-2xl bg-white hover:shadow-md transition-shadow"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center mb-6">
                    <SafeIcon icon={info.icon} className="text-2xl text-primary" aria-hidden="true" />
                  </div>
                  <h3 className="text-xl font-bold text-primary mb-2">{info.title}</h3>
                  <p className="text-primary font-semibold mb-1">{info.detail}</p>
                  <p className="text-sm text-secondary font-medium">{info.subDetail}</p>
                </motion.div>
              ))}
              
              <div className="p-8 bg-primary rounded-2xl text-white">
                <div className="flex items-center gap-3 mb-4">
                  <SafeIcon icon={FiClock} className="text-xl" aria-hidden="true" />
                  <h4 className="font-bold">Jam Operasional</h4>
                </div>
                <div className="space-y-2 opacity-90 text-sm font-medium">
                  <p className="flex justify-between"><span>Senin - Jumat:</span> <span>09:00 - 17:00</span></p>
                  <p className="flex justify-between"><span>Sabtu:</span> <span>09:00 - 13:00</span></p>
                  <p className="flex justify-between"><span>Minggu:</span> <span>Tutup</span></p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white border border-divider rounded-3xl p-8 md:p-12 shadow-sm"
              >
                <div className="flex items-center gap-4 mb-10">
                  <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center">
                    <SafeIcon icon={FiMessageSquare} className="text-xl text-green-600" aria-hidden="true" />
                  </div>
                  <h2 className="text-2xl font-bold text-primary">Kirim Pesan</h2>
                </div>

                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="fullName" className="text-sm font-bold text-primary uppercase tracking-wider">Nama Lengkap</label>
                      <input 
                        id="fullName"
                        type="text" 
                        placeholder="Contoh: Dr. Ahmad Fauzi" 
                        className="w-full px-5 py-4 bg-gray-50 border border-divider rounded-xl focus:ring-2 focus:ring-primary/20 outline-none transition-all font-medium"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="email" className="text-sm font-bold text-primary uppercase tracking-wider">Email Institusi</label>
                      <input 
                        id="email"
                        type="email" 
                        placeholder="ahmad.fauzi@univ.ac.id" 
                        className="w-full px-5 py-4 bg-gray-50 border border-divider rounded-xl focus:ring-2 focus:ring-primary/20 outline-none transition-all font-medium"
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="serviceType" className="text-sm font-bold text-primary uppercase tracking-wider">Jenis Layanan</label>
                    <div className="relative">
                      <select 
                        id="serviceType"
                        className="w-full px-5 py-4 bg-gray-50 border border-divider rounded-xl focus:ring-2 focus:ring-primary/20 outline-none transition-all font-medium appearance-none"
                      >
                        <option value="">Pilih Layanan...</option>
                        <option value="editing">Editing Naskah & Buku</option>
                        <option value="layout">Layout Jurnal & Buku</option>
                        <option value="cover">Desain Cover</option>
                        <option value="paraphrase">Parafrase & Formatting</option>
                        <option value="other">Lainnya</option>
                      </select>
                      <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none text-secondary">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="message" className="text-sm font-bold text-primary uppercase tracking-wider">Pesan Bapak/Ibu</label>
                    <textarea 
                      id="message"
                      rows="5" 
                      placeholder="Jelaskan kebutuhan atau kendala akademik Anda..." 
                      className="w-full px-5 py-4 bg-gray-50 border border-divider rounded-xl focus:ring-2 focus:ring-primary/20 outline-none transition-all font-medium resize-none"
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="w-full bg-primary text-white py-5 rounded-xl font-bold text-lg flex items-center justify-center gap-3 hover:opacity-95 transition-all shadow-lg active:scale-[0.98]"
                  >
                    <SafeIcon icon={FiSend} aria-hidden="true" />
                    <span>Kirim Sekarang</span>
                  </button>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="pb-24 px-4 font-medium">
        <div className="max-w-7xl mx-auto h-[400px] bg-gray-100 rounded-3xl border border-divider flex items-center justify-center relative overflow-hidden group">
          <div className="text-center z-10 p-8 bg-white/90 backdrop-blur-sm rounded-2xl border border-divider shadow-xl">
            <SafeIcon icon={FiMapPin} className="text-4xl text-primary mx-auto mb-4" aria-hidden="true" />
            <h3 className="text-xl font-bold text-primary mb-2">Lokasi Kantor Kami</h3>
            <p className="text-secondary mb-4">Jl. Sudirman No. 123, Jakarta Selatan</p>
            <button className="text-primary font-bold border-b-2 border-primary hover:opacity-70 transition-all">
              Buka di Google Maps
            </button>
          </div>
          <div className="absolute inset-0 opacity-20 pointer-events-none" style={{backgroundImage: 'radial-gradient(#2F415E 1px, transparent 1px)', backgroundSize: '20px 20px'}}></div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;